/**
 * Merges two sets of parameters (`queryParams` and `filterParams`), removes any `null` or `undefined`
 * values, and returns a clean object with only valid parameters.
 *
 * @param queryParams - The first set of parameters (e.g., from the URL or query string).
 * @param filterParams - The second set of parameters (e.g., from filter settings).
 * @param removeKeys - Optional object to specify which uneeded keys to remove 
 * @returns An object with the merged and cleaned parameters.
 */

export function mergeCleanParams(
    queryParams: Record<string, any> = {},
    filterParams: Record<string, any> = {},
    removeKeys: Record<string, any> = {}
): Record<string, any> {
    const finalParams: Record<string, any> = {};
    const combinedParams = { ...queryParams, ...filterParams };

    for (const key in combinedParams) {
        // Skip the key if it is in the removeKeys object
        if (key in removeKeys) {
            continue; // Skip this key if it is in the removeKeys object
        }

        // Ensure only valid values are added to finalParams
        if (combinedParams[key] != null && combinedParams[key] !== undefined) {
            finalParams[key] = combinedParams[key];
        }
    }

    return finalParams;
}


